import { PlatformUnits, ProfileViewResponse } from "@/generated-api";
import BadgeWithImage from "./BadgeWithImage";
import { cmToFeetInches } from "../onboarding/data-form/HeightSelector";
import { useGetAccountSettings } from "@/tanstack-hooks";
import OpenToBadges from "./OpenToBadges";
import vape from "../../assets/vape.png";
import ruler from "../../assets/ruler.png";
import cocktail from "../../assets/cocktail.png";
import tattoo from "../../assets/tattoo-device.png";
import { getTranslatedEnumLabel } from "@/lib/utils";
import { useTranslation } from "@/hooks/useTranslation";

export default function GeneralSection({
  profileView,
}: {
  profileView: ProfileViewResponse;
}) {
  const t = useTranslation();
  const accountSettingsQuery = useGetAccountSettings();
  const units: PlatformUnits | undefined =
    accountSettingsQuery.data?.preferred_units;
  const isMetric = units !== PlatformUnits.US;

  return (
    <div className="flex flex-col gap-y-2">
      <span className="text-lg">{t.PROFILE_VIEW.LABELS.GENERAL_SECTION}</span>
      <div className="flex flex-wrap w-full gap-x-3 gap-y-4">
        {profileView.height_cm && (
          <BadgeWithImage
            image={<img src={ruler} className="w-6 h-6" />}
            title={
              isMetric
                ? profileView.height_cm + " cm"
                : cmToFeetInches(profileView.height_cm)
            }
          />
        )}
        {profileView.open_to && <OpenToBadges openTo={profileView.open_to} />}
        {profileView.smoker && (
          <BadgeWithImage
            image={<img src={vape} className="w-6 h-6" />}
            title={getTranslatedEnumLabel(t, profileView.smoker)}
          />
        )}
        {profileView.drinking && (
          <BadgeWithImage
            image={<img src={cocktail} className="w-5 h-5" />}
            title={getTranslatedEnumLabel(t, profileView.drinking)}
          />
        )}
        {profileView.tattoos && (
          <BadgeWithImage
            image={<img src={tattoo} className="w-6 h-6" />}
            title={getTranslatedEnumLabel(t, profileView.tattoos)}
          />
        )}
      </div>
    </div>
  );
}
